import { useRef, useState, useEffect } from "react";

type IntersectionObserverCallback = (entry: IntersectionObserverEntry) => void;

export const useIntersectionObserver = (
  callback: IntersectionObserverCallback,
  options?: IntersectionObserverInit,
): React.Dispatch<React.SetStateAction<HTMLElement | null>> => {
  const observer = useRef<IntersectionObserver | null>(null);
  const [target, setTarget] = useState<HTMLElement | null>(null);
  useEffect(() => {
    if (observer.current) observer.current.disconnect();

    observer.current = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        callback(entry);
      }
    }, options);

    const { current: currentObserver } = observer;
    if (target) currentObserver.observe(target);

    return () => {
      if (currentObserver) currentObserver.disconnect();
    };
  }, [target, options, callback]);

  return setTarget;
};
